export default {"src":"/_next/static/media/_pro_license_outlined.70cf491e.svg","height":24,"width":24};